import React, { Component } from "react";
import { SALE_TYPES, api } from "../../utils/api";

export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Chandigarh",
  "Puducherry",
  "Lakshadweep",
  "Andaman & Nicobar Islands",
  "Dadra & Nagar Haveli",
  "Daman & Diu",
];

class SaleGuestDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agents: [],
      soldToType: "client",
      branches: [],
      brokers: [],
      loadingBranches: false,
      selectedBranchId: "",
      selectedBrokerId: "",
      _selectedAgencyName: "",
    };
    // ── Refs for auto-focus on validation error ───────────────────────────────
    this.refs_map = {
      sale_type: React.createRef(),
      booking_date: React.createRef(),
      sold_to: React.createRef(),
      billing_state_sale: React.createRef(),
      guest_phone: React.createRef(),
      client_email: React.createRef(),
    };
    this._prevErrors = {};
  }

  componentDidMount() {
    const { user, formData, onChange, newlyAddedAgent } = this.props;
    if (!formData.booking_date)
      onChange("booking_date", new Date().toISOString().slice(0, 10));
    if (user && !formData.booked_by) {
      const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
      if (name) onChange("booked_by", name);
    }
    api
      .get("/agents", { params: { is_active: 1, limit: 500 } })
      .then((res) => {
        const all = res.data?.data || [];
        const agents = all.filter(
          (a) =>
            a.agent_type === "Buyers" ||
            a.agent_type === "Both" ||
            !a.agent_type,
        );
        this.setState({ agents }, () => {
          // Returning from the "Add Agent" detour — switch to Agent mode and
          // select the one just created. Reuses handleAgentSelect so email,
          // billing state, and branches fill in exactly as a manual pick would.
          if (newlyAddedAgent?.agency_name) {
            this.setState({ soldToType: "agent" }, () => {
              this.handleAgentSelect(newlyAddedAgent.agency_name);
            });
          }
        });
      })
      .catch(() => {});
  }

  componentDidUpdate(prevProps) {
    const { user, formData, onChange, errors } = this.props;
    if (user && !formData.booked_by && prevProps.user !== user) {
      const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
      if (name) onChange("booked_by", name);
    }

    // ── Auto-focus first errored required field when errors change ────────────
    if (errors && errors !== prevProps.errors) {
      const ORDER = [
        "sale_type",
        "booking_date",
        "sold_to",
        "billing_state_sale",
        "guest_phone",
        "client_email",
      ];
      for (const key of ORDER) {
        if (errors[key] && this.refs_map[key]?.current) {
          const el = this.refs_map[key].current;
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          try {
            el.focus();
          } catch (_) {}
          break;
        }
      }
    }
  }

  handleChange(e) {
    this.props.onChange(e.target.name, e.target.value);
  }

  async handleAgentSelect(selectedName) {
    this.props.onChange("sold_to", selectedName);
    this.setState({
      branches: [],
      brokers: [],
      selectedBranchId: "",
      selectedBrokerId: "",
      _agentName: selectedName,
      _selectedAgencyName: selectedName,
    });
    this.props.onChange("client_email", "");
    this.props.onChange("selected_branch_name", "");
    this.props.onChange("branch", "");

    if (!selectedName) {
      this.props.onChange("billing_state_sale", "");
      return;
    }

    const agent = this.state.agents.find((a) => a.agency_name === selectedName);
    if (!agent) return;
    if (agent.billing_state)
      this.props.onChange("billing_state_sale", agent.billing_state);

    this.setState({ loadingBranches: true });
    try {
      const res = await api.get(`/agents/${agent.id}`);
      const branches = res.data?.data?.branches || [];
      const brokers = res.data?.data?.brokers || [];
      this.setState({ branches, brokers });

      if (branches.length === 0) {
        if (agent.email) this.props.onChange("client_email", agent.email);
        if (agent.billing_state)
          this.props.onChange("billing_state_sale", agent.billing_state);
      } else if (branches.length === 1) {
        const b = branches[0];
        this.setState({ selectedBranchId: String(b.id) });
        this.props.onChange("selected_branch_name", b.branch_name);
        this.props.onChange("branch", b.branch_name);
        this.props.onChange(
          "client_email",
          b.manager_email || agent.email || "",
        );
        const state = b.billing_state || agent.billing_state || "";
        if (state) this.props.onChange("billing_state_sale", state);
      }
    } catch (e) {
      if (agent.email) this.props.onChange("client_email", agent.email);
    } finally {
      this.setState({ loadingBranches: false });
    }
  }

  handleBranchSelect(branchId) {
    this.setState({ selectedBranchId: branchId, selectedBrokerId: "" });
    const { branches } = this.state;
    if (!branchId) {
      const parentAgent = this.state.agents.find(
        (a) => branches.length > 0 && branches[0].agent_id === a.id,
      );
      if (parentAgent?.email)
        this.props.onChange("client_email", parentAgent.email);
      this.props.onChange("selected_branch_name", "");
      this.props.onChange("branch", "");
      return;
    }
    const branch = branches.find((b) => String(b.id) === String(branchId));
    if (branch) {
      this.props.onChange("selected_branch_name", branch.branch_name);
      this.props.onChange("branch", branch.branch_name);
      const parentAgent = this.state.agents.find(
        (a) => a.id === branch.agent_id,
      );
      this.props.onChange(
        "client_email",
        branch.manager_email || parentAgent?.email || "",
      );
      const state = branch.billing_state || parentAgent?.billing_state || "";
      if (state) this.props.onChange("billing_state_sale", state);
    }
  }

  render() {
    const { formData, errors, section } = this.props;
    const showSale = !section || section === "sale";
    const showGuest = !section || section === "guest";
    const { agents, soldToType, branches, loadingBranches, selectedBranchId } =
      this.state;
    const user = this.props.user;
    const bookedByName = [user?.first_name, user?.last_name]
      .filter(Boolean)
      .join(" ");
    const R = this.refs_map;

    return (
      <div className="space-y-6">
        {/* ── Sale Details ── */}
        {showSale && (
          <section>
            <h3 className="section-title">Sale Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="field-group">
                <label>Sale Type *</label>
                <select
                  ref={R.sale_type}
                  name="sale_type"
                  value={formData.sale_type || ""}
                  onChange={this.handleChange.bind(this)}
                  style={
                    errors?.sale_type
                      ? {
                          borderColor: "#DC2626",
                          boxShadow: "0 0 0 2px rgba(220,38,38,0.15)",
                        }
                      : {}
                  }
                >
                  <option value="">Select type</option>
                  {SALE_TYPES.map((t) => (
                    <option key={t}>{t}</option>
                  ))}
                </select>
                {errors?.sale_type && (
                  <span className="error">{errors.sale_type}</span>
                )}
              </div>
              <div className="field-group">
                <label>Booking Date *</label>
                <input
                  ref={R.booking_date}
                  type="date"
                  name="booking_date"
                  value={formData.booking_date || ""}
                  onChange={this.handleChange.bind(this)}
                  style={
                    errors?.booking_date
                      ? {
                          borderColor: "#DC2626",
                          boxShadow: "0 0 0 2px rgba(220,38,38,0.15)",
                        }
                      : {}
                  }
                />
                {errors?.booking_date && (
                  <span className="error">{errors.booking_date}</span>
                )}
              </div>
              <div className="field-group">
                <label>Booked By</label>
                <input
                  type="text"
                  name="booked_by"
                  value={formData.booked_by || bookedByName || ""}
                  readOnly
                  style={{
                    cursor: "default",
                    color: "#111827",
                    fontWeight: 600,
                    background: "#F0F9FF",
                    border: "1.5px solid #BFDBFE",
                  }}
                  onChange={() => {}}
                />
                <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 3 }}>
                  Auto-filled from logged-in user
                </p>
              </div>
            </div>
          </section>
        )}

        {/* ── Guest Info ── */}
        {showGuest && (
          <section>
            <h3 className="section-title">Guest Info</h3>

            {/* Row 1: Guest Name + Phone */}
            <div
              className="grid grid-cols-1 md:grid-cols-2 gap-4"
              style={{ marginBottom: 12 }}
            >
              <div className="field-group">
                <label>Guest Name</label>
                <input
                  type="text"
                  name="guest_name"
                  placeholder="Full name"
                  value={formData.guest_name || ""}
                  onChange={this.handleChange.bind(this)}
                />
              </div>
              <div className="field-group">
                <label>Guest Phone</label>
                <input
                  ref={R.guest_phone}
                  type="tel"
                  name="guest_phone"
                  placeholder="+91 98765 43210"
                  value={formData.guest_phone || ""}
                  maxLength={15}
                  onChange={(e) =>
                    this.props.onChange(
                      "guest_phone",
                      e.target.value.replace(/[^0-9+\-\s]/g, ""),
                    )
                  }
                  style={
                    errors?.guest_phone
                      ? {
                          borderColor: "#DC2626",
                          boxShadow: "0 0 0 2px rgba(220,38,38,0.15)",
                        }
                      : {}
                  }
                />
                {errors?.guest_phone && (
                  <span className="error">{errors.guest_phone}</span>
                )}
              </div>
            </div>

            {/* Row 2: Sold To | Branch | Booker */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: 12,
                marginBottom: 12,
              }}
            >
              {/* Sold To */}
              <div className="field-group">
                <label>Sold To *</label>
                <div
                  ref={R.sold_to}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: `1.5px solid ${errors?.sold_to ? "#DC2626" : "#D1D5DB"}`,
                    boxShadow: errors?.sold_to
                      ? "0 0 0 2px rgba(220,38,38,0.15)"
                      : "none",
                    borderRadius: 10,
                    overflow: "hidden",
                    background: "#fff",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      background: "#F3F4F6",
                      flexShrink: 0,
                      borderRight: "1.5px solid #D1D5DB",
                    }}
                  >
                    {[
                      ["client", "👤 Client"],
                      ["agent", "🏢 Agent"],
                    ].map(([t, lbl]) => (
                      <button
                        key={t}
                        type="button"
                        onClick={() => {
                          this.setState({
                            soldToType: t,
                            branches: [],
                            selectedBranchId: "",
                            selectedBrokerId: "",
                            _selectedAgencyName: "",
                            brokers: [],
                          });
                          this.props.onChange("sold_to", "");
                          this.props.onChange("client_email", "");
                          this.props.onChange("selected_branch_name", "");
                          this.props.onChange("branch", "");
                        }}
                        style={{
                          padding: "10px 12px",
                          border: "none",
                          cursor: "pointer",
                          fontSize: 12,
                          fontWeight: 700,
                          whiteSpace: "nowrap",
                          background:
                            soldToType === t
                              ? t === "agent"
                                ? "#1E2D4F"
                                : "#2563EB"
                              : "transparent",
                          color: soldToType === t ? "#fff" : "#6B7280",
                          transition: "all 0.15s",
                        }}
                      >
                        {lbl}
                      </button>
                    ))}
                  </div>
                  {soldToType === "agent" ? (
                    <>
                      <select
                        value={this.state._selectedAgencyName || ""}
                        onChange={(e) => this.handleAgentSelect(e.target.value)}
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          padding: "10px 10px",
                          fontSize: 13,
                          color: "#111827",
                          background: "transparent",
                          fontFamily: "Sora,sans-serif",
                        }}
                      >
                        <option value="">Select agency…</option>
                        {agents.map((a) => (
                          <option key={a.id} value={a.agency_name}>
                            {a.agency_name}
                          </option>
                        ))}
                      </select>
                      {this.props.onAddAgent && (
                        <button
                          type="button"
                          onClick={this.props.onAddAgent}
                          title="Add a new agent"
                          style={{
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            padding: "0 10px",
                            height: "100%",
                            border: "none",
                            borderLeft: "1.5px solid #D1D5DB",
                            background: "#EFF6FF",
                            color: "#1D4ED8",
                            fontSize: 12,
                            fontWeight: 700,
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          + Add Agent
                        </button>
                      )}
                    </>
                  ) : (
                    <input
                      type="text"
                      name="sold_to"
                      placeholder="Enter client name"
                      value={formData.sold_to || ""}
                      onChange={this.handleChange.bind(this)}
                      style={{
                        flex: 1,
                        border: "none",
                        outline: "none",
                        padding: "10px 10px",
                        fontSize: 13,
                        color: "#111827",
                        background: "transparent",
                        fontFamily: "Sora,sans-serif",
                      }}
                    />
                  )}
                </div>
                {soldToType === "agent" && formData.sold_to && (
                  <p style={{ fontSize: 11, color: "#059669", marginTop: 3 }}>
                    ✓ Agent: <strong>{formData.sold_to}</strong>
                    {formData.branch ? (
                      <>
                        {" "}
                        · Branch: <strong>{formData.branch}</strong>
                      </>
                    ) : (
                      ""
                    )}
                  </p>
                )}
                {errors?.sold_to && (
                  <span className="error">{errors.sold_to}</span>
                )}
              </div>

              {/* Branch */}
              <div className="field-group">
                {soldToType === "agent" ? (
                  <>
                    <label>
                      Branch
                      {branches.length > 1 && (
                        <span style={{ color: "#DC2626" }}> *</span>
                      )}
                      {this.state._agentName && (
                        <span
                          style={{
                            fontSize: 10,
                            color: "#9CA3AF",
                            fontWeight: 400,
                            marginLeft: 6,
                            textTransform: "none",
                            letterSpacing: 0,
                          }}
                        >
                          ({this.state._agentName})
                        </span>
                      )}
                    </label>
                    {!this.state._selectedAgencyName ? (
                      <div
                        style={{
                          padding: "10px 12px",
                          fontSize: 13,
                          color: "#C9D0D9",
                          border: "1.5px solid #E5E7EB",
                          borderRadius: 10,
                          fontStyle: "italic",
                        }}
                      >
                        Select agent first
                      </div>
                    ) : loadingBranches ? (
                      <div
                        style={{
                          padding: "10px 12px",
                          fontSize: 13,
                          color: "#9CA3AF",
                          border: "1.5px solid #D1D5DB",
                          borderRadius: 10,
                        }}
                      >
                        Loading…
                      </div>
                    ) : branches.length === 0 ? (
                      <div
                        style={{
                          padding: "10px 12px",
                          fontSize: 13,
                          color: "#9CA3AF",
                          border: "1.5px solid #D1D5DB",
                          borderRadius: 10,
                          fontStyle: "italic",
                        }}
                      >
                        No branches
                      </div>
                    ) : (
                      <select
                        value={selectedBranchId}
                        onChange={(e) =>
                          this.handleBranchSelect(e.target.value)
                        }
                        style={{
                          width: "100%",
                          border: `1.5px solid ${selectedBranchId ? "#2563EB" : "#D1D5DB"}`,
                          borderRadius: 10,
                          padding: "10px 12px",
                          fontFamily: "Sora,sans-serif",
                          fontSize: 13,
                          color: "#111827",
                          outline: "none",
                          background: selectedBranchId ? "#EFF6FF" : "#fff",
                        }}
                      >
                        <option value="">Select branch…</option>
                        {branches.map((b) => (
                          <option key={b.id} value={String(b.id)}>
                            {b.branch_name}
                          </option>
                        ))}
                      </select>
                    )}
                    {selectedBranchId &&
                      (() => {
                        const b = branches.find(
                          (br) => String(br.id) === String(selectedBranchId),
                        );
                        if (!b) return null;
                        return (
                          <p
                            style={{
                              fontSize: 11,
                              color: "#2563EB",
                              marginTop: 4,
                            }}
                          >
                            ✓ {b.branch_name}
                            {b.billing_state ? ` · ${b.billing_state}` : ""}
                          </p>
                        );
                      })()}
                  </>
                ) : (
                  <div />
                )}
              </div>

              {/* Booker */}
              <div className="field-group">
                {soldToType === "agent" && selectedBranchId ? (
                  (() => {
                    const branchBrokers = this.state.brokers.filter(
                      (bk) => String(bk.branch_id) === String(selectedBranchId),
                    );
                    const b = branches.find(
                      (br) => String(br.id) === String(selectedBranchId),
                    );
                    if (branchBrokers.length === 0)
                      return (
                        <div>
                          <label>Booker</label>
                          <div
                            style={{
                              padding: "10px 12px",
                              fontSize: 13,
                              color: "#9CA3AF",
                              border: "1.5px solid #E5E7EB",
                              borderRadius: 10,
                              fontStyle: "italic",
                            }}
                          >
                            No bookers for this branch
                          </div>
                        </div>
                      );
                    return (
                      <div>
                        <label>
                          Booker
                          <span
                            style={{
                              fontSize: 10,
                              color: "#9CA3AF",
                              fontWeight: 400,
                              marginLeft: 6,
                              textTransform: "none",
                              letterSpacing: 0,
                            }}
                          >
                            ({b?.branch_name})
                          </span>
                        </label>
                        <select
                          value={this.state.selectedBrokerId || ""}
                          onChange={(e) => {
                            const brokerId = e.target.value;
                            this.setState({ selectedBrokerId: brokerId });
                            const selected = branchBrokers.find(
                              (bk) => String(bk.id) === String(brokerId),
                            );
                            if (selected) {
                              if (selected.email)
                                this.props.onChange(
                                  "client_email",
                                  selected.email,
                                );
                            } else {
                              const br = branches.find(
                                (br) =>
                                  String(br.id) === String(selectedBranchId),
                              );
                              if (br)
                                this.props.onChange(
                                  "client_email",
                                  br.manager_email || "",
                                );
                            }
                          }}
                          style={{
                            width: "100%",
                            border: `1.5px solid ${this.state.selectedBrokerId ? "#7C3AED" : "#D1D5DB"}`,
                            borderRadius: 10,
                            padding: "10px 12px",
                            fontFamily: "Sora,sans-serif",
                            fontSize: 13,
                            color: "#111827",
                            outline: "none",
                            background: this.state.selectedBrokerId
                              ? "#F5F3FF"
                              : "#fff",
                          }}
                        >
                          <option value="">Select booker (optional)</option>
                          {branchBrokers.map((bk) => (
                            <option key={bk.id} value={String(bk.id)}>
                              {bk.name}
                            </option>
                          ))}
                        </select>
                        {this.state.selectedBrokerId &&
                          (() => {
                            const bk = branchBrokers.find(
                              (bk) =>
                                String(bk.id) ===
                                String(this.state.selectedBrokerId),
                            );
                            return bk ? (
                              <p
                                style={{
                                  fontSize: 11,
                                  color: "#7C3AED",
                                  marginTop: 4,
                                }}
                              >
                                ✓ Booker: <strong>{bk.name}</strong> · Sold to:{" "}
                                <strong>{formData.sold_to}</strong>
                              </p>
                            ) : null;
                          })()}
                      </div>
                    );
                  })()
                ) : (
                  <div />
                )}
              </div>
            </div>

            {/* Row 3: Client Email + Billing State */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 12,
                marginTop: 12,
              }}
            >
              <div className="field-group">
                <label>Client Email</label>
                <input
                  ref={R.client_email}
                  type="email"
                  name="client_email"
                  placeholder="client@example.com"
                  value={formData.client_email || ""}
                  onChange={this.handleChange.bind(this)}
                  style={
                    errors?.client_email
                      ? {
                          borderColor: "#DC2626",
                          boxShadow: "0 0 0 2px rgba(220,38,38,0.15)",
                        }
                      : {}
                  }
                />
                {errors?.client_email ? (
                  <span className="error">{errors.client_email}</span>
                ) : (
                  <p style={{ fontSize: 11, color: "#9CA3AF", marginTop: 3 }}>
                    {soldToType === "agent" && this.state.selectedBrokerId
                      ? "✓ Auto-filled from booker"
                      : soldToType === "agent" && selectedBranchId
                        ? "✓ Auto-filled from branch"
                        : soldToType === "agent" && formData.sold_to
                          ? "✓ Auto-filled from agent"
                          : "Confirmation email sent on booking (optional)"}
                  </p>
                )}
              </div>
              <div className="field-group">
                <label>Billing State (Sale) *</label>
                <select
                  ref={R.billing_state_sale}
                  name="billing_state_sale"
                  value={formData.billing_state_sale || ""}
                  onChange={this.handleChange.bind(this)}
                  style={
                    errors?.billing_state_sale
                      ? {
                          borderColor: "#DC2626",
                          boxShadow: "0 0 0 2px rgba(220,38,38,0.15)",
                        }
                      : {}
                  }
                >
                  <option value="">Select state</option>
                  {INDIAN_STATES.map((s) => (
                    <option key={s}>{s}</option>
                  ))}
                </select>
                {formData.billing_state_sale && soldToType === "agent" && (
                  <p style={{ fontSize: 11, color: "#059669", marginTop: 3 }}>
                    ✓ Auto-filled from agent/branch
                  </p>
                )}
                {errors?.billing_state_sale && (
                  <span className="error">{errors.billing_state_sale}</span>
                )}
              </div>
            </div>

            {/* Row 4: Follow Up */}
            <div
              style={{
                marginTop: 12,
                padding: "14px 16px",
                background: "#F8FAFF",
                border: "1.5px solid #E0E7FF",
                borderRadius: 12,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  flexWrap: "wrap",
                }}
              >
                <label
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#374151",
                    margin: 0,
                    whiteSpace: "nowrap",
                  }}
                >
                  Follow Up
                </label>
                <div style={{ display: "flex", gap: 8 }}>
                  {["Yes", "No"].map((opt) => {
                    const active = (formData.follow_up || "No") === opt;
                    return (
                      <button
                        key={opt}
                        type="button"
                        onClick={() => {
                          this.props.onChange("follow_up", opt);
                          if (opt === "No")
                            this.props.onChange("follow_up_date", "");
                        }}
                        style={{
                          padding: "7px 20px",
                          borderRadius: 8,
                          fontSize: 13,
                          fontWeight: 600,
                          cursor: "pointer",
                          transition: "all 0.15s",
                          border: active
                            ? `2px solid ${opt === "Yes" ? "#059669" : "#6B7280"}`
                            : "1.5px solid #D1D5DB",
                          background: active
                            ? opt === "Yes"
                              ? "#059669"
                              : "#6B7280"
                            : "#fff",
                          color: active ? "#fff" : "#374151",
                          boxShadow: active
                            ? "0 2px 6px rgba(0,0,0,0.12)"
                            : "none",
                        }}
                      >
                        {opt === "Yes" ? "✓ Yes" : "✗ No"}
                      </button>
                    );
                  })}
                </div>
                {(formData.follow_up || "No") === "Yes" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      flex: 1,
                      minWidth: 220,
                    }}
                  >
                    <label
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#059669",
                        margin: 0,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Follow Up Date *
                    </label>
                    <input
                      type="date"
                      name="follow_up_date"
                      value={formData.follow_up_date || ""}
                      onChange={this.handleChange.bind(this)}
                      onClick={(e) => {
                        try {
                          e.target.showPicker();
                        } catch (_) {}
                      }}
                      style={{
                        flex: 1,
                        cursor: "pointer",
                        border: `1.5px solid ${errors?.follow_up_date ? "#DC2626" : "#BBF7D0"}`,
                        borderRadius: 8,
                        padding: "7px 10px",
                        fontSize: 13,
                        outline: "none",
                        background: formData.follow_up_date
                          ? "#F0FDF4"
                          : "#fff",
                      }}
                    />
                    {errors?.follow_up_date && (
                      <span className="error">{errors.follow_up_date}</span>
                    )}
                  </div>
                )}
                {(formData.follow_up || "No") === "Yes" &&
                  formData.follow_up_date && (
                    <span
                      style={{
                        fontSize: 11,
                        color: "#059669",
                        fontWeight: 600,
                      }}
                    >
                      📅 Follow up on{" "}
                      {new Date(formData.follow_up_date).toLocaleDateString(
                        "en-IN",
                        { day: "numeric", month: "short", year: "numeric" },
                      )}
                    </span>
                  )}
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}

export default SaleGuestDetails;